import { useState } from "react";
import { Loader2, Check, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/api";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await api.post("/newsletter", { email });
      setState("done");
    } catch {
      setState("idle");
      toast.error("Could not subscribe right now. Please try again.");
    }
  };

  if (state === "done") {
    return (
      <div className="mt-12 bg-tnn-soft rounded-3xl p-8 flex items-start gap-4" data-testid="newsletter-success">
        <span className="w-10 h-10 rounded-full bg-tnn-purple flex items-center justify-center shrink-0">
          <Check className="w-5 h-5 text-white" />
        </span>
        <div>
          <p className="font-display font-semibold text-tnn-ink">You're on the list.</p>
          <p className="mt-1 text-sm text-tnn-muted">Thank you. We write occasionally, and only when it's worth reading.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-12 bg-white border border-tnn-ink/8 rounded-3xl p-8" data-testid="newsletter-signup">
      <div className="flex items-center gap-2.5">
        <Mail className="w-4 h-4 text-tnn-purple" />
        <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-tnn-purple">Occasional Notes</p>
      </div>
      <p className="mt-3 font-display text-xl font-semibold text-tnn-ink">Enjoyed this? Get the next one by email.</p>
      <p className="mt-1.5 text-sm text-tnn-muted leading-relaxed">
        Short, thoughtful notes on nutrition, technology and building for health. No noise.
      </p>
      <form onSubmit={onSubmit} className="mt-5 flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          data-testid="newsletter-email-input"
          className="flex-1 bg-tnn-warm border border-tnn-ink/12 rounded-full px-5 py-3 text-sm text-tnn-ink placeholder:text-tnn-muted/60 focus:outline-none focus:border-tnn-purple focus:ring-2 focus:ring-tnn-purple/15 transition-[border-color,box-shadow] duration-200"
        />
        <button
          type="submit"
          disabled={state === "loading"}
          data-testid="newsletter-subscribe-button"
          className="inline-flex items-center justify-center gap-2 bg-tnn-purple text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-tnn-deep transition-colors duration-200 disabled:opacity-60"
        >
          {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
        </button>
      </form>
    </div>
  );
}
